import React, { useEffect } from 'react';
import { AlertCircle, X } from 'lucide-react';

export const FlashMessage = ({ message, type = 'info', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const bgColors = {
    info: 'bg-slate-800/90 border-cyan-500/50 text-cyan-400',
    error: 'bg-red-900/90 border-red-500/50 text-red-400',
    warning: 'bg-amber-900/90 border-amber-500/50 text-amber-400'
  };

  return (
    <div className={`fixed bottom-24 left-1/2 -translate-x-1/2 z-[150] px-6 py-3 rounded-xl border backdrop-blur-md shadow-2xl animate-in slide-in-from-bottom-4 fade-in duration-300 flex items-center gap-3 ${bgColors[type]}`}>
      <AlertCircle className="w-5 h-5 shrink-0" />
      <span className="text-sm font-medium whitespace-nowrap">{message}</span>
      <button onClick={onClose} className="ml-2 hover:opacity-70 transition-opacity">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
